import { Injectable } from '@angular/core';
import { LearningApp } from '@app/modules/learning-apps/models/learning-app.model';
import { LEARNING_APPS } from '@app/modules/learning-apps/resolvers/queries/learning-apps.query';

import { AppSyncHelper } from '@coach-bot/data-access/core';
import { GetLearningAppsQuery } from 'app/API.service';
import { ObjectMapper } from 'json-object-mapper';

import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';

@Injectable({ providedIn: 'root' })
export class LearningAppsService {
  constructor(private readonly appSyncHelper: AppSyncHelper) {}

  getLearningApps(): Observable<LearningApp[]> {
    return this.appSyncHelper.query<GetLearningAppsQuery, string>(LEARNING_APPS, '').pipe(
      map((res) => {
        const data = ObjectMapper.deserializeArray(LearningApp, res.getLearningApps);
        return data
          .filter((app: LearningApp) => (app.productivityIntegration ? app.courses.length : true))
          .sort((current: LearningApp, previous: LearningApp) => {
            // Conditions are applied in order on purpose.
            // As we have to sort the rows on base productivity integration
            // at first and then on the base of app Name.
            if (current.productivityIntegration > previous.productivityIntegration) {
              return -1;
            }

            if (current.productivityIntegration < previous.productivityIntegration) {
              return 1;
            }

            if (current.learningAppName > previous.learningAppName) {
              return 1;
            }

            if (current.learningAppName < previous.learningAppName) {
              return -1;
            }

            return 0;
          });
      })
    );
  }
}
